import { standard } from '../../constants';

export default {
  ...standard('CREATE', 'sessions'),
  ...standard('DELETE', 'sessions'),
  ...standard('GET', 'sessions'),
};



// WEBPACK FOOTER //
// ./src/modules/sessions/constants.js